<template>
  <div>
    <div class="page-bar" style="margin-bottom:10px;">
      <ul class="page-breadcrumb">
          <li>
              <router-link :to="{name:'home'}">Accueil</router-link>
              <i class="fa fa-circle"></i>
          </li>
          <li>
              <router-link :to="{name:'settings'}">Paramètre du compte</router-link>
          </li>
      </ul>
    </div>
    <div class="row">
      <div class="col-lg-6">
          <!-- BEGIN VALIDATION STATES-->
          <div class="portlet light portlet-fit portlet-form bordered">
              <div class="portlet-title">
                  <div class="caption">
                      <i class=" icon-settings font-green"></i>
                      <span class="caption-subject font-green sbold uppercase">Mon compte</span>
                  </div>
              </div>
              <div class="portlet-body">
                  <!-- BEGIN FORM-->
                  <form id="formSettings"  class="form-horizontal">
                      <div class="form-body">
                          <div class="form-group form-md-line-input">
                              <label class="col-md-3 control-label" for="form_control_1">Prénom
                                  <span class="required" aria-required="true">*</span>
                              </label>
                              <div class="col-md-9">
                                  <input type="text" class="form-control" placeholder="" v-model="user.firstname" required data-parsley-trigger="change">
                                  <div class="form-control-focus"> </div>
                              </div>
                          </div>
                          <div class="form-group form-md-line-input">
                              <label class="col-md-3 control-label" for="form_control_1">Nom
                                  <span class="required" aria-required="true">*</span>
                              </label>
                              <div class="col-md-9">
                                  <input type="text" class="form-control" placeholder="" v-model="user.lastname" required data-parsley-trigger="change">
                                  <div class="form-control-focus"> </div>
                              </div>
                          </div>
                          <div class="form-group form-md-line-input">
                              <label class="col-md-3 control-label" for="form_control_1">Email
                                <span class="required" aria-required="true">*</span>
                              </label>
                              <div class="col-md-9">
                                  <input type="text" class="form-control" v-model="user.email" placeholder="" required data-parsley-type="email" data-parsley-trigger="change">
                                  <div class="form-control-focus"> </div>
                              </div>
                          </div>
                      </div>
                      <div class="form-actions">
                          <div class="row">
                              <div class="col-md-offset-3 col-md-9">
                                  <a class="btn green" v-on:click="updateUser()">Valider les modifications</a>
                                  <a v-on:click="$router.back()" class="btn default">Annuler</a>
                              </div>
                          </div>
                      </div>
                  </form>
                  <!-- END FORM-->
              </div>
          </div>
          <!-- END VALIDATION STATES-->
      </div>
      <div class="col-lg-6">
        <div class="mt-element-ribbon bg-grey-steel">
            <div class="ribbon  ribbon-clip ribbon-color-info uppercase">
              <div class="ribbon-sub ribbon-clip"></div> Informations
            </div>
            <p class="ribbon-content">
              <div class="mt-element-list" style="margin-top:-25px;">
                <div class="mt-list-container list-simple">
                  <div class="note note-warning">
                      <h4 class="block"> Avertissement</h4>
                      <p> Pour valider toutes modifications votre mot de passe actuel vous sera demandé.</p>
                      <p> La modification de votre adresse email ou votre mot de passe entraînera le changement de vos identifiants de connexion ! </p>
                  </div>
                  <div class="note note-info">
                      <h4 class="block"> Changement de mot de passe ?</h4>
                        <p> <a class="btn btn-info" v-on:click="showPopup.password=true">Changer mon mot de passe</a> </p>
                  </div>
                </div>
              </div>
            </p>
        </div>
      </div>
    </div>


    <div v-show="showPopup.confirm" class="sweet-alert showSweetAlert visible"  data-allow-outside-click="false" data-animation="pop" style="border:1px dashed gray;display: block;">

      <div class="sa-icon pulseWarning"><i style="font-size:50px;position:relative;top:30px;" class="icon-lock text-warning"></i></div>
      <h2>Sécurité </h2>
      <p class="lead text-muted text-left">
        Merci de saisir votre mot de passe pour valider les modifications que vous avez effectuées.<br><br>
        <form id="formPassword">
          <input type="password" class="form-control" placeholder="Mot de passe actuel" autocomplete="off" required v-model="password">
        </form>
      </p>
      <div class="sa-button-container">
        <button class="cancel btn btn-lg btn-default btn-danger" v-on:click="showPopup.confirm=false">Annuler</button>
        <div class="sa-confirm-button-container">
          <button class="confirm btn btn-lg btn-success" v-on:click="validateUpdate()">Valider</button>
        </div>
      </div>
    </div>

    <div v-show="showPopup.success" class="sweet-alert showSweetAlert visible" data-allow-outside-click="false" data-animation="pop" style="border:1px dashed gray;display: block;">
      <div class="sa-icon sa-success animate" style="display: block;">
        <span class="sa-line sa-tip animateSuccessTip"></span>
        <span class="sa-line sa-long animateSuccessLong"></span>

        <div class="sa-placeholder"></div>
        <div class="sa-fix"></div>
      </div>
      <h2>Félicitation </h2>
      <p class="lead text-muted text-left">
        Les changements ont été effectués. <br> Veuillez vous déconnecter pour que ces changements prennent effet.
      </p>
      <div class="sa-button-container">
        <div class="sa-confirm-button-container">
          <button class="confirm btn btn-lg btn-success" v-on:click="showPopup.success=false;logout()">Ok</button>
        </div>
      </div>
    </div>

    <div v-show="showPopup.password" class="sweet-alert showSweetAlert visible" data-allow-outside-click="false" data-animation="pop" style="border:1px dashed gray;display: block;">
      <div class="sa-icon sa-info" style="display: block;"></div>
      <h2>Changement de mot de passe </h2>
      <p class="lead text-muted text-left">
        <form id="formEditPassword">
          <input type="password" class="form-control" placeholder="Mot de passe actuel" autocomplete="off" required v-model="password">
          <input type="password" class="form-control mt-10" placeholder="Nouveau mot de passe" autocomplete="off" required id="newPassword" v-on:change="reValidateInput('confirmNewPassword')" data-parsley-equalto="#confirmNewPassword" data-parsley-error-message="Les mots de passe ne correspondent pas."	 v-model="newPassword">
          <input type="password" class="form-control mt-10" placeholder="Confirmation du nouveau mot de passe" id="confirmNewPassword" v-on:change="reValidateInput('newPassword')" data-parsley-equalto="#newPassword" data-parsley-error-message="Les mots de passe ne correspondent pas."	 autocomplete="off" required>
        </form>
      </p>
      <div class="sa-button-container">
        <button class="cancel btn btn-lg btn-default btn-danger" v-on:click="showPopup.password=false">Annuler</button>
        <div class="sa-confirm-button-container">
          <button class="confirm btn btn-lg btn-success" v-on:click="editPassword()">Valider</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import storage from "../storage/data.js";
import users from '../requests/users.js'

export default {
  name: 'settings',
  data () {
    return{
      user:storage.data.user,
      showPopup:{
        confirm:false,
        password:false,
        success:false
      },
      password:"",
      newPassword:""
    }
  },
  mounted:function(){
    // $('#formEditPassword').parsley().subscribe('parsley:field:validate', function () {});
  },
  methods:{
    reValidateInput(id){
      setTimeout(function(){
        $("#"+id).parsley().validate();
      },50)
    },
    updateUser(){
      $('#formSettings').parsley().validate()
      if($("#formSettings").parsley().isValid()){
        this.showPopup.confirm = true;
      }
    },
    validateUpdate(){
      $('#formPassword').parsley().validate()
      if($("#formPassword").parsley().isValid()){

        var credentials = {
          username:this.user.username,
          password:this.password
        }
        var parent = this;
        users.verifyPassword(this,credentials,function(isOk){
          if(isOk){
            parent.showPopup.confirm = false;
            parent.password = "";
            // On MAJ l'USER !!!
            users.updateById(parent,parent.user.id,parent.user,function(user,err){
              if(user){
                parent.showPopup.success = true;
              }
              else {
                toastr.error(err,"ERREUR");
              }
            })
          }
          else{
            toastr.error("Mot de passe incorrect.","ERREUR");
          }
        })
      }
    },
    editPassword(){
      $('#formEditPassword').parsley().validate()
      if($("#formEditPassword").parsley().isValid()){
        var credentials = {
          oldPassword:this.password,
          newPassword:this.newPassword
        }
        var parent = this;
        users.changePassword(this,credentials,function(err){
          if(!err){
            parent.showPopup.password = false;
            parent.password = "";
            parent.newPassword = "";
            parent.showPopup.success = true;
          }
          else{
            toastr.error(err,"ERREUR");
          }
        })
      }
    },
    logout(){
      if(storage){
        storage.logout();
      }
      this.$router.push({name:'login'});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// settings.vue?8e61e014